import TGT_LOGO_B64 from "./tgtLogoB64";

const QR_CODE_B64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXIAAAFyAQAAAADAX2ykAAAC4ElEQVR4nO1bUY6jMAy1DVI/QZoD7FHSq/VIewM4yhxgJfJZicor26S0rBRAq+0G4fcxE/DTyMrDjuNkkGEPetpFB3B+HrRiX8L5edCKfQnn50Er9iWcnwet2Jdw/hnmByfUAL0O2ukdQEy26wf92Q7awT0xP7BgSKMuInLXMOMVKjVx2f5vBp2UH1OE9lgDXlXaKPFr0V1/2p+toM1Mw+n5gUew+OUBgDt4x+nnZwVUOr/X+IXKUjP8d39WQGuEk/Pr6XcjUkYAy8gCBrgjhJ86+pg/5Px/MT99qpohaJE1AOA1XkTZh5XPf/f3N4O2UxXO3xK/vIhaHfWtRLMG9gyfzzyoMD7Y5seqKl1wm1HepR+dPSZ0pflPzt8wP3xrk7RWMEftdFxkk3Rh6KXd4f2N4+ZnBKhHDN/1iNBUjKFjwMAPZIhfujtOKbw0/8n5m/OzAEAbVrL1ZWtnjVZuqdXz89G+NzDdTDx4CqpKN6O8qFgX4alxWZr/5Pw82KK2EfGaNLLSCp6N6fkT8PnMgwrNz8NrQlZ9IQwpU89Ku76H1JdtwVVpRWTJymYWkdOeyfU97PnvVVKzbojwhxZZDzkfHKVxOWv+OX+2g3Zwz8iHVFqlY97wVk6zpGZbmD0/H3397bRWtibWU9BGS2evnw+tL7Mss89LHFNqBnmnRZbre2x9QcsoOzqyIuvtVk5Ij14/H1PfGS874fDsdEzCu74H7j8rqnGK2FiP3LcDI8SvUYro2vvPx+4/vy7C84YX7HGus0vzn5y/6/4k3+SuZPiWU0GcrkOryH4+eMjvrV48IzS/pmwdWK5zxFZEfl7xKM1/cv6u+eEuXphvchNLkNpZep1S4POZBxXKb9L5oLQmAZo7Qt8+EMLwQGa+42Qt1f+toHPm595yciX5eQAMg+bjivU1hq5Y/8n5WaD/f3cWlDf/AefnQSv2JZyfB63Yl3B+HrRiX8L5edCKHU7O/w2S7gnBRC+aywAAAABJRU5ErkJggg==";

const getTeamName = (team) => {
    if (!team) return "?";
    if (team.name && team.name.trim()) return team.name.trim();
    if (team.players && team.players.length > 0) return team.players.map((p) => p.name).join(" / ");
    return `Team ${team.id}`;
};

const getMatchResult = (matches, rowTeamId, colTeamId) => {
    const match = matches.find((m) => {
        const t1 = m.team1?.id ?? m.team1Id;
        const t2 = m.team2?.id ?? m.team2Id;
        return (t1 === rowTeamId && t2 === colTeamId) || (t1 === colTeamId && t2 === rowTeamId);
    });
    if (!match?.sets?.length) return "";

    const isRowTeamAsTeam1 = (match.team1?.id ?? match.team1Id) === rowTeamId;
    return match.sets
        .slice()
        .sort((a, b) => a.setNumber - b.setNumber)
        .map((set) => isRowTeamAsTeam1
            ? `${set.player1Score}:${set.player2Score}`
            : `${set.player2Score}:${set.player1Score}`)
        .join(", ");
};

const buildStandingsBlock = (standings, tournamentTeams) => {
    if (!standings || standings.length === 0) return "";

    const rows = standings.map((row, idx) => {
        const teamId = row.teamId ?? row.playerId;
        const team = tournamentTeams.find((t) => t.id === teamId);
        const name = getTeamName(team) || teamId;
        return `<tr>
            <td>${idx + 1}</td>
            <td style="text-align:left">${name}</td>
            <td>${row.matches}</td>
            <td>${row.wins}</td>
            <td>${row.losses}</td>
            <td>${row.setsWon}</td>
            <td>${row.setsLost}</td>
            <td><strong>${row.points}</strong></td>
        </tr>`;
    }).join("");

    return `
        <h3>Tabelle</h3>
        <table>
            <thead><tr>
                <th>Platz</th><th>Team</th><th>Spiele</th>
                <th>Siege</th><th>Niederl.</th>
                <th>Sätze +</th><th>Sätze -</th><th>Punkte</th>
            </tr></thead>
            <tbody>${rows}</tbody>
        </table>`;
};

const buildPageHeader = (tournamentName, logoB64) => `
    <div class="page-header">
        <div>
            <div class="page-header-title">${tournamentName || "Turnier"} – Spielpaarungen</div>
        </div>
        <img src="${logoB64}" alt="TGT Logo" />
    </div>`;

const buildPageFooter = () => `
    <div class="page-footer">
        <img src="${QR_CODE_B64}" alt="QR-Code" />
        <span class="footer-text">Ergebnisse auch online eintragen unter:<br><strong>https://tennis-thedinghausen.app</strong></span>
    </div>`;

const buildGroupPage = (group, tournamentTeams, matches, standings, tournamentName, logoB64, isLast) => {
    const teamIds = group.teamIds || group.playerIds || [];
    const teams = teamIds.map((id) => tournamentTeams.find((t) => t.id === id)).filter(Boolean);
    if (teams.length === 0) return "";

    const headerCells = teams.map((t) => `<th>${getTeamName(t)}</th>`).join("");
    const rows = teams.map((rowTeam, rowIdx) => {
        const cells = teams.map((colTeam, colIdx) => {
            if (rowIdx === colIdx) return `<td class="diag">&#x2715;</td>`;
            const result = getMatchResult(matches, rowTeam.id, colTeam.id);
            return `<td class="${result ? "has-result" : ""}">${result}</td>`;
        }).join("");
        return `<tr><th>${getTeamName(rowTeam)}</th>${cells}</tr>`;
    }).join("");

    return `
        <div class="page${isLast ? "" : " page-break"}">
            ${buildPageHeader(tournamentName, logoB64)}
            <h2>${group.name || `Gruppe ${group.id}`}</h2>
            <table>
                <thead><tr><th></th>${headerCells}</tr></thead>
                <tbody>${rows}</tbody>
            </table>
            ${buildStandingsBlock(standings, tournamentTeams)}
            ${buildPageFooter()}
        </div>`;
};

const renderAndPrint = (pages, tournamentName) => {
    const html = `<!DOCTYPE html>
<html lang="de">
<head>
<meta charset="UTF-8">
<title>${tournamentName || "Turnier"} – Spielpaarungen</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; font-size: 12px; margin: 0; color: #111; }
  .page { padding: 16px; display: flex; flex-direction: column; min-height: 100vh; }
  .page-break { page-break-after: always; }
  .page-header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #333; padding-bottom: 8px; margin-bottom: 16px; }
  .page-header img { width: 70px; height: auto; }
  .page-header-title { font-size: 16px; font-weight: bold; margin-bottom: 2px; }
  h2 { font-size: 14px; margin: 0 0 10px; }
  h3 { font-size: 12px; margin: 18px 0 6px; }
  .content { flex: 1; }
  table { border-collapse: collapse; width: auto; margin-bottom: 8px; }
  th, td { border: 1px solid #555; padding: 6px 10px; text-align: center; min-width: 60px; }
  thead th, tbody th { background: #eee; font-weight: bold; text-align: left; }
  td.diag { background: #ccc; color: #444; font-size: 14px; }
  td.has-result { font-weight: bold; }
  .page-footer { display: flex; align-items: center; gap: 14px; border-top: 1px solid #bbb; padding-top: 10px; margin-top: 24px; }
  .page-footer img { width: 70px; height: 70px; }
  .footer-text { font-size: 12px; color: #333; }
  .footer-text strong { font-size: 13px; }
  @media print {
    @page { size: landscape; margin: 8mm; }
    body { margin: 0; }
    .page { min-height: auto; padding: 0; }
    .page-break { page-break-after: always; }
  }
</style>
</head>
<body>
${pages}
<script>window.onload = function() { window.print(); };<\/script>
</body>
</html>`;

    const win = window.open("", "_blank");
    if (!win) {
        alert("Popup wurde blockiert. Bitte Popup-Blocker für diese Seite deaktivieren.");
        return;
    }
    win.document.write(html);
    win.document.close();
};

export const exportGroupTablesPdf = async (groups, tournamentTeams, tournamentName, api) => {
    const [matchesByGroup, standingsByGroup] = await Promise.all([
        Promise.all(groups.map((group) =>
            api.get(`/tournaments/matches/group/${group.id}`)
                .then((data) => Array.isArray(data) ? data : [])
                .catch(() => [])
        )),
        Promise.all(groups.map((group) =>
            api.get(`/tournaments/groups/${group.id}/standings`)
                .then((data) => Array.isArray(data) ? data : [])
                .catch(() => [])
        )),
    ]);

    const pages = groups
        .map((group, i) => buildGroupPage(
            group, tournamentTeams,
            matchesByGroup[i], standingsByGroup[i],
            tournamentName, TGT_LOGO_B64,
            i === groups.length - 1
        ))
        .join("");

    renderAndPrint(pages, tournamentName);
};
